import React, { ChangeEvent } from "react";
import InputField from "components/InputField";

interface PasswordStepProps {
  username: string;
  setUsername: (value: string) => void;
  password: string;
  setPassword: (value: string) => void;
  repeatPassword: string;
  setRepeatPassword: (value: string) => void;
  errors: {
    username: string | null;
    password: string | null;
    repeatPassword: string | null;
  };
}

const PasswordStep: React.FC<PasswordStepProps> = ({
  username,
  setUsername,
  password,
  setPassword,
  repeatPassword,
  setRepeatPassword,
  errors,
}) => {
  return (
    <>
      <InputField
        label="이름/닉네임"
        type="text"
        value={username}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setUsername(e.target.value)
        }
        placeholder="이름/닉네임"
        error={errors.username || undefined}
        required
      />
      <InputField
        label="비밀번호"
        type="password"
        value={password}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setPassword(e.target.value)
        }
        placeholder="비밀번호"
        error={errors.password || undefined}
        required
      />
      <InputField
        label="비밀번호 확인"
        type="password"
        value={repeatPassword}
        onChange={(e: ChangeEvent<HTMLInputElement>) =>
          setRepeatPassword(e.target.value)
        }
        placeholder="비밀번호 확인"
        error={errors.repeatPassword || undefined}
        required
      />
    </>
  );
};

export default PasswordStep;
